import Controller from '../abstracts/Controller';
import 'scss-templates/t-pdp.scss';

export default class PdpController extends Controller {
  static get COMPONENTS() {
    return [
      'CarouselComponent',
      'SizeSelectorComponent',
      'PdpMainComponent',
      'PdpImagesComponent',
      'SkuInfoAccordionComponent',
      'CompleteLookComponent',
      'AddToCartComponent',
      'NotifyMeComponent',
      'WishlistComponent',
      'RecommendationEngineComponent',
      'GoogleRecommendationEngineComponent',
      'EditorialCoverInfiniteComponent',
      'JournalComponent',
      'LookbookComponent',
      'StoreEventComponent',
      //giftcard component
      'PdpGiftCardComponent',
    ];
  }
}
